import { Constants } from "@eagerdog/constants";
import { IEventRegisterRow } from "../../../services/helper.service.js";

export namespace ABILostAndFound {
  export const form: IEventRegisterRow[] = [
    {
      allowDuplicates: true,
      inputs: [
        {
          type: "dropdown",
          flex: 2,
          label: Constants.dog_class_element.lf_containers,
          elementType: "level",
          options: [
            { value: "None", id: "None" },
            {
              value: Constants.dog_class_element_level.seeker,
              id: Constants.dog_class_element_level.seeker,
            },
            {
              value: Constants.dog_class_element_level.locater,
              id: Constants.dog_class_element_level.locater,
            },
            {
              value: Constants.dog_class_element_level.discover,
              id: Constants.dog_class_element_level.discover,
            },
          ],
        },
        {
          type: "dropdown",
          defaultValue: "None",
          label: "Section",
          showElement: Constants.dog_class_element.lf_containers,
          elementType: "section",
          options: [
            { value: "None", id: "None" },
            {
              value: Constants.dog_class_section.on_leash,
              id: Constants.dog_class_section.on_leash,
            },
            {
              value: Constants.dog_class_section.unleashed,
              id: Constants.dog_class_section.unleashed,
            },
          ],
        },
      ],
    },
    {
      allowDuplicates: true,
      inputs: [
        {
          type: "dropdown",
          flex: 2,
          label: Constants.dog_class_element.lf_interiors,
          elementType: "level",
          options: [
            { value: "None", id: "None" },
            {
              value: Constants.dog_class_element_level.seeker,
              id: Constants.dog_class_element_level.seeker,
            },
            {
              value: Constants.dog_class_element_level.locater,
              id: Constants.dog_class_element_level.locater,
            },
            {
              value: Constants.dog_class_element_level.discover,
              id: Constants.dog_class_element_level.discover,
            },
          ],
        },
        {
          type: "dropdown",
          defaultValue: "None",
          label: "Section",
          showElement: Constants.dog_class_element.lf_interiors,
          elementType: "section",
          options: [
            { value: "None", id: "None" },
            {
              value: Constants.dog_class_section.on_leash,
              id: Constants.dog_class_section.on_leash,
            },
            {
              value: Constants.dog_class_section.unleashed,
              id: Constants.dog_class_section.unleashed,
            },
          ],
        },
      ],
    },
    {
      allowDuplicates: true,
      inputs: [
        {
          type: "dropdown",
          flex: 2,
          label: Constants.dog_class_element.lf_exteriors,
          elementType: "level",
          options: [
            { value: "None", id: "None" },
            {
              value: Constants.dog_class_element_level.seeker,
              id: Constants.dog_class_element_level.seeker,
            },
            {
              value: Constants.dog_class_element_level.locater,
              id: Constants.dog_class_element_level.locater,
            },
            {
              value: Constants.dog_class_element_level.discover,
              id: Constants.dog_class_element_level.discover,
            },
          ],
        },
        {
          type: "dropdown",
          defaultValue: "None",
          label: "Section",
          showElement: Constants.dog_class_element.lf_exteriors,
          elementType: "section",
          options: [
            { value: "None", id: "None" },
            {
              value: Constants.dog_class_section.on_leash,
              id: Constants.dog_class_section.on_leash,
            },
            {
              value: Constants.dog_class_section.unleashed,
              id: Constants.dog_class_section.unleashed,
            },
          ],
        },
      ],
    },
  ];
}
